export default {
  translation: {
    common: {
      emailOrUsername: '이메일 또는 사용자 이름',
      invalidEmailOrUsername: '잘못된 이메일 또는 사용자 이름',
      invalidCredentials: '잘못된 자격 증명',
      invalidPassword: '잘못된 비밀번호',
      noInternetConnection: '인터넷 연결 없음',
      pageNotFound_title: '페이지를 찾을 수 없음',
      password: '비밀번호',
      projectManagement: '프로젝트 관리',
      serverConnectionFailed: '서버 연결 실패',
      unknownError: '알 수 없는 오류, 나중에 다시 시도하세요',
      useSingleSignOn: 'Single Sign-On(SSO) 사용',
    },

    action: {
      logIn: '로그인',
      logInWithSSO: 'SSO로 로그인',
    },
  },
};
